import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class CookieHandlerService {
    constructor(
        private cookieService: CookieService
    ) {}
    public SetCookie(key: string, value: any): void {
        this.cookieService.set(key, value, null, '/', null, true, "None");
    }
    public GetCookie(key: string): string {
        return this.cookieService.get(key);
    }
    public DeleteCookies(keys: string[]): void {
        keys.forEach((key: string, index: number) => {
            this.cookieService.delete(key, '/');
        });
    }
    public FlushAll(): void {
        this.cookieService.deleteAll();
    }
    public deleteCookie(name: string) {
        const domain = window.location.hostname;
        if (domain === 'localhost') {
            document.cookie = name + '= ; path=/ ; max-age=0';
        } else {
            document.cookie = name + '= ; path=/; secure; max-age=0;';
        }
    }
}
